import { AutoComplete, AutoCompleteProps, Input, Spin } from 'antd';
import { t } from 'i18next';
import React from 'react';

interface CustomAutoCompleteProps extends AutoCompleteProps {
  isLoading: boolean;
  placeholder?: string;
}

export default function CustomAutoComplete({
  isLoading,
  placeholder,
  value,
  ...props
}: CustomAutoCompleteProps) {
  return (
    <AutoComplete
      {...props}
      value={value}
      notFoundContent={t('global:no_data')}
      dropdownRender={(menu) => (
        <>
          {isLoading ? (
            <div className="text-center py-2">
              <Spin size="small" />
            </div>
          ) : (
            menu
          )}
        </>
      )}
    >
      <Input value={value} placeholder={placeholder} />
    </AutoComplete>
  );
}
